export const cleanWhenEnabledFilterIsSet = filter => {
  const { enabled, includeDisabled, ...rest } = filter

  if (enabled !== undefined) {
    const newFilter = { ...rest, enabled: enabled === 'true' }
    return newFilter
  }

  return filter
}
